/* custom-drawer.js — mobile nav drawer for custom-header.
   Plain toggle driven by a [data-open] attribute (not native <details>,
   so the panel can slide via CSS transform/transition instead of the
   browser's abrupt display:none toggle). Closes on backdrop click, the
   close button, Escape, or clicking any link inside. */
(function () {
  /** @param {HTMLElement} root */
  function init(root) {
    if (root.dataset.drawerInit) return;
    root.dataset.drawerInit = '1';

    var header = root.closest('.custom-header');
    var toggle = header ? header.querySelector('[data-custom-drawer-toggle]') : null;
    var panel = root.querySelector('[data-custom-drawer-panel]');
    if (!toggle || !panel) return;

    function open() {
      root.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }

    function close() {
      root.removeAttribute('data-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (root.hasAttribute('data-open')) close();
      else open();
    });

    root.querySelectorAll('[data-custom-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-custom-drawer]').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
